import { rolePermissionResource, RolePermissionResource } from '@witkac/kartamiejska-resources';
import { PermissionRelationObjectType } from '@witkac/kartamiejska-shared';

import store from '@/store/store';
import { AbstractModule } from '../abstract.module';

/**
 * Moduł uprawnień ról
 *
 * @class RolePermissions
 * @extends {AbstractModule<RolePermission>}
 */
class RolePermissions extends AbstractModule<RolePermissionResource> {
  public state = {
    list: [],
    count: undefined
  };

  public mutations = {
    /**
     * Zapisuje listę do store
     *
     * @param {*} localState
     * @param {PermissionRelationObjectType[]} list
     */
    saveList(localState: any, list: PermissionRelationObjectType[]): void {
      localState.list = list;
      localState.count = list.length;
    },
    /**
     * Usuwa encję z listy
     *
     * @param localState stan lokalny
     * @param id identyfikator encji
     */
    remove(localState: any, id: number): void {
      localState.list.splice(
        localState.list.findIndex((item: any) => item.permission.id === id),
        1
      );
      localState.count -= 1;
    }
  };
  public actions = {
    /**
     * Pobiera listę encji
     *
     * @param context context
     * @param roleId identyfikator roli
     */
    list: async (context: any, roleId: number): Promise<void> => {
      const list = await this.resource.list(roleId);
      context.commit('saveList', list);
    },
    /**
     * Usuwa encję
     *
     * @param context context
     * @param data dane do wysłania do api
     */
    remove: async (context: any, data: any): Promise<void> => {
      await this.resource.delete(data.permissionId, data.roleId);
      context.commit('remove', data.permissionId);
    },
    /**
     * Dodaje encję
     *
     * @param context context
     * @param data dane do wysłania do API
     */
    add: async (context: any, data: any): Promise<void> => {
      await this.resource.add(data.permissionId, data.roleId);
      store.dispatch('roles/rolePermission/list', data.roleId);
    }
  };
}

export default new RolePermissions(rolePermissionResource);
